// Shared icon resolvers for the device / OS / browser surfaces in the WC
// check details page (Polaris bundle) and the order metabox (lean bundle).
// Kept Polaris-free so the order widget can import it.

import {
  AiFillApple as AppleIcon,
  AiFillAndroid as AndroidIcon,
} from "react-icons/ai";
import {
  FaSafari as SafariIcon,
  FaMobileAlt as MobileIcon,
  FaChrome as ChromeIcon,
  FaLaptop as LaptopIcon,
  FaEdge as EdgeIcon,
  FaFirefox as FirefoxIcon,
  FaWindows as WindowsIcon,
} from "react-icons/fa";
import { CgBrowser as DefaultWebBrowserIcon } from "react-icons/cg";
import { MdOutlineDeviceUnknown as DefaultOSIcon } from "react-icons/md";

export function getDeviceIcon(device) {
  const mapping = {
    mobile: MobileIcon,
    tablet: MobileIcon,
    smarttv: MobileIcon,
    console: MobileIcon,
    wearable: MobileIcon,
    embedded: MobileIcon,
  };
  return mapping[device] || LaptopIcon;
}

export function getBrowserIcon(browser) {
  if (!browser) return DefaultWebBrowserIcon;
  if (browser.match(/Chrome/)) return ChromeIcon;
  if (browser.match(/Safari/)) return SafariIcon;
  if (browser.match(/Edge/)) return EdgeIcon;
  if (browser.match(/Firefox/)) return FirefoxIcon;
  return DefaultWebBrowserIcon;
}

export function getOSIcon(os) {
  if (!os) return DefaultOSIcon;
  if (os.match(/Windows/)) return WindowsIcon;
  if (os.match(/Mac OS/) || os.match(/iOS/)) return AppleIcon;
  if (os.match(/Android/)) return AndroidIcon;
  return DefaultOSIcon;
}
